import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectAppId } from 'core-components/sitebuilder/store/selectors/selectAppId'
import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

import { getExcludedEmailsKey } from './getExcludedEmailsKey'

export const useUserCrud = (excludedEmails: string[] = []) => {
  const excludedEmailsKey = getExcludedEmailsKey(excludedEmails)
  const appId = useSelector(selectAppId)
  const userCrud = useMemo(
    () =>
      CrudStore.get(
        'AppUsersAppsSearch',
        `acknowledgment-manager-picker:${appId}:${excludedEmailsKey}`
      ),
    [appId, excludedEmailsKey]
  )

  useEffect(() => {
    userCrud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'Id',
          operator: Operator.CONTAINS,
          value: '@hp.com',
        },
        {
          field: 'AppId',
          operator: Operator.EQUAL,
          value: appId,
        },
        ...(excludedEmailsKey ? excludedEmailsKey.split(';') : []).map((email) => ({
          field: 'Id',
          operator: Operator.NOTEQUAL,
          value: email,
        })),
      ],
    })
  }, [userCrud, appId, excludedEmailsKey])

  return userCrud
}
